import React, { useState } from "react";
import MobileContentAccordion from "./MobileAccordion";
import DesktopGridContent from "./DesktopGrid";

interface IProps {
  deviceDisplay: "Desktop" | "Mobile";
  appHostedAt: string | null;
  currentWindowWidth: number | null;
}

const VirtualRealityModalGameInfo: React.FC<IProps> = ({ deviceDisplay, appHostedAt, currentWindowWidth }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <div
        className={`${
          deviceDisplay === "Mobile" && currentWindowWidth && currentWindowWidth >= 1024
            ? "tw-absolute tw-right-[60px]"
            : deviceDisplay === "Mobile" && currentWindowWidth && currentWindowWidth < 1024
            ? "tw-relative tw-right-[0px]"
            : deviceDisplay === "Mobile"
            ? "tw-relative lg:tw-absolute tw-right-0"
            : "tw-absolute tw-left-0 tw-top-[50vh]"
        }`}
      >
        <button
          className={`${
            appHostedAt && appHostedAt === "bosshunting"
              ? "tw-border-[2px] tw-border-[#F609FF] tw-bg-[#C53CFF] tw-p-[12px] tw-rounded-full"
              : "tw-bg-[#F609FF] tw-p-[12px] tw-rounded-tr-[100px] tw-rounded-tl-[100px] tw-rounded-br-[100px] tw-rounded-bl-[100px] lg:tw-rounded-tr-[15px] lg:tw-rounded-br-[15px] lg:tw-rounded-tl-[0] lg:tw-rounded-bl-[0]"
          }`}
          onClick={toggleModal}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 11.5C0 17.5709 4.928 22.5 11 22.5C17.083 22.5 22 17.5709 22 11.5C22 5.4269 17.083 0.5 11 0.5C4.928 0.5 0 5.4269 0 11.5ZM10.032 15.669C10.032 16.1959 10.472 16.637 11 16.637C11.528 16.637 11.957 16.1959 11.957 15.669V10.807C11.957 10.2779 11.528 9.84998 11 9.84998C10.472 9.84998 10.032 10.2779 10.032 10.807V15.669ZM11.0117 6.3081C10.3933 6.3081 9.90107 6.81292 9.90107 7.41871C9.90107 8.02449 10.3933 8.51669 10.9991 8.51669C11.6175 8.51669 12.1097 8.02449 12.1097 7.41871C12.1097 6.81292 11.6175 6.3081 11.0117 6.3081Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      {isModalOpen && (
        <div className="tw-fixed tw-z-50 tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50 tw-px-[10px] lg:tw-px-0">
          <div className="tw-bg-[#393B41] tw-max-w-[1108px] tw-w-full tw-mx-auto tw-rounded-lg tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100 tw-p-[20px]">
            <div className="tw-flex tw-justify-end">
              <button className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none" onClick={toggleModal}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M19.1183 1.05664L1.48218 18.6928" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M19.124 18.7039L1.47314 1.04932" stroke="#C2C0C3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
            {!appHostedAt && (
              <div className="tw-hidden lg:tw-block tw-max-h-[70vh] tw-h-full tw-overflow-y-auto">
                <DesktopGridContent />
              </div>
            )}
            {appHostedAt && appHostedAt === "bosshunting" ? (
              <div className="tw-block tw-max-h-[70vh] tw-h-full tw-overflow-y-auto">
                <MobileContentAccordion />
              </div>
            ) : (
              <div className="tw-block lg:tw-hidden tw-max-h-[70vh] tw-h-full tw-overflow-y-auto">
                <MobileContentAccordion />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default VirtualRealityModalGameInfo;
